// Tiny IndexedDB-backed queue for offline submissions. We deliberately
// don't pull in idb-keyval or workbox — this app only writes one record
// per submission, so the native API surface is enough.

const DB_NAME = "worksafestory";
const DB_VERSION = 1;
const STORE = "pending_submissions";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function withStore(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const store = tx.objectStore(STORE);
    let result;
    Promise.resolve(fn(store))
      .then((r) => { result = r; })
      .catch(reject);
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}

export async function enqueueSubmission({ employee_name, employee_id, reason, photo }) {
  // Read the file into an ArrayBuffer so it survives the IDB serializer.
  const buffer = await photo.arrayBuffer();
  return withStore("readwrite", (store) =>
    new Promise((resolve, reject) => {
      const req = store.add({
        employee_name,
        employee_id,
        reason,
        photo_name: photo.name || "photo.jpg",
        photo_type: photo.type || "image/jpeg",
        photo_buffer: buffer,
        queued_at: new Date().toISOString(),
      });
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    })
  );
}

export async function listPending() {
  return withStore("readonly", (store) =>
    new Promise((resolve, reject) => {
      const req = store.getAll();
      req.onsuccess = () => resolve(req.result || []);
      req.onerror = () => reject(req.error);
    })
  );
}

export async function removePending(id) {
  return withStore("readwrite", (store) =>
    new Promise((resolve, reject) => {
      const req = store.delete(id);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    })
  );
}

export async function countPending() {
  const items = await listPending();
  return items.length;
}
